export default {
    resultTitle: "Résultats de tests",
    resultDescription: "Retrouvez tous vos résultats de test en un seul endroit",
    testResultPage1Title: "Aperçu",
    testResultPage2Title: "Analyse Détaillée",
    overallScoreLabel: "Score global",
    testPerformanceScoreLabel: "Performance",
    resultDescriptorLabel: "Descripteur de résultat",
    resultDescriptorUnavailable: "Non disponible pour ce score",
    testResultStrengthsLabel: "Points forts",
    testResultWeaknessesLabel: "Points faibles",
    retakeTestActionButtonLabel: "Repasser le test",
    viewDetailedTestResultsActionButtonLabel: "Voir les résultats détaillés",

    seeResultsActionLabel: "Voir les résultats",
    errorTagArticleUsageLabel: "Usage des articles",
    errorTagCoherenceLabel: "Cohérence",
    errorTagFillerWordsLabel: "Mots de remplissage",
    errorTagInvalidOptionLabel: "Option invalide",
    errorTagOffTopicLabel: "Hors sujet",
    errorTagPronunciationLabel: "Prononciation",
    errorTagTenseConfusionLabel: "Confusion des temps",
    errorTagWordChoiceLabel: "Choix des mots",
    errorTagSubjectVerbAgreementLabel: "Accord sujet-verbe",
    testCompletionDateLabel: "Terminé le {{date}}",
    shareResultsActionButtonLabel: "Partager le résultat",
    shareResultsDialogTitle: "Partager votre résultat",
    shareResultsShareActionLabel: "Partager",
    shareResultsDownloadActionLabel: "Télécharger l'image",
    shareResultsImageError: "L'image du résultat n'a pas pu être créée. Veuillez réessayer.",
    shareResultsText: "J'ai obtenu {{score}} au {{test}} avec LinguaScore",
    shareResultCardFooter: "Résultat de test d'entraînement · linguascores.com",
    shareResultCardBadge: "RÉSULTAT D'ENTRAÎNEMENT",
    shareResultQuestionsLabel: "Questions répondues",
    shareResultTimeLabel: "Temps passé",
    shareResultImprovementsLabel: "À améliorer",
    seeAllResultsActionLabel: "Voir tous les résultats"
}
